import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enTranslations from './locales/en';
import arTranslations from './locales/ar';

const resources = {
  en: enTranslations,
  ar: arTranslations,
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,

    // Language detection options
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },

    interpolation: {
      escapeValue: false, // React already does escaping
    },

    // Default namespace
    defaultNS: 'common',
    ns: [
      'auth',
      'cities',
      'common',
      'categories',
      'countries',
      'currencies',
      'customers',
      'invoices',
      'notifications',
      'orders',
      'paymentMethods',
      'roles',
      'settings',
      'shipforme',
      'shippingCompanies',
      'userAddresses',
      'users',
      'vouchers',
      'faq',
      'faqCategory',
    ],

    // RTL languages
    supportedLngs: ['en', 'ar'],
  });

export default i18n;
